import { useQuery } from "@tanstack/react-query";
import {
  UserProfileDto,
  UserRole,
  UsersControllerGetUsersList200Response,
} from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_USERS = "GET_USERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetUsersRequest {
  name?: string;
  companyId?: string;
  search?: string;
  orderBy?: string;
  orderDirection?: string;
  pageNumber?: number;
  pageSize?: number;
}

const getUsers = async (
  params?: GetUsersRequest,
): Promise<UsersControllerGetUsersList200Response> => {
  const { companyId, name, search, orderBy, orderDirection, pageNumber, pageSize } =
    params ?? {};

  const response = await usersApi.usersControllerGetUsersList(
    name,
    companyId,
    search,
    orderBy,
    orderDirection,
    pageNumber,
    pageSize,
  );

  return response.data;
};

export const useGetUsers = (
  user: UserProfileDto | null,
  params?: GetUsersRequest,
): {
  users?: UsersControllerGetUsersList200Response;
  usersEnabled: boolean;
  isPendingGetUsers: boolean;
  refetchUsers: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data, refetch } = useQuery({
    queryKey: [DOMAIN_USERS, ACTION_GET_USERS, params],
    queryFn: () => getUsers(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    users: data,
    usersEnabled: enabled,
    isPendingGetUsers: isPending,
    refetchUsers: refetch,
  };
};
